import { InjectionToken } from "@angular/core";

export const APP_RELEASE = new InjectionToken<string>("APP-RELEASE");
